
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from 'api/axios';

export const useDeleteConversation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const deleteConversation = async (conversationId: string, agentId: string) => {
    setIsLoading(true);
    setError(null);
    try {
      await api.delete(`/conversations/${conversationId}`);
      navigate(`/dashboard/agents/${agentId}/chat`);
    } catch (err: any) {
      setError(err.message || 'Failed to delete conversation.');
    } finally {
      setIsLoading(false);
    }
  };

  return { deleteConversation, isLoading, error };
}; 